import L from 'leaflet'
import icon from 'leaflet/dist/images/marker-icon.png';


export const IconLocation = L.icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [35, 35],
    className: "leaflet-venue-icon",
})

